export const getParticipationRoute = (isSocialFeedEnabled: boolean): '/updates' | '/collaborate' =>
  isSocialFeedEnabled ? '/updates' : '/collaborate';
